export const getState = (filters) => {
  let selectedState = getDefaultState(filters)
  const filtersCopy = structuredClone(filters)
  const getAllStates = filtersCopy.find((value) => value.key === 'state')?.values
  const statesConfig = filtersCopy.find((value) => value.key === 'state')
  const result = getAllStates?.map(({STATE_NAME}) => STATE_NAME)
  result?.splice(0, 1)
  selectedState = selectedState?.includes(statesConfig?.entireUnitedStateLabel) ? result : selectedState

  return selectedState
}

export const getDefaultState = (filters) => {
  return filters?.find((value) => value.key === 'state')?.default
}
